import logo from './logo.svg';
import './App.css';
import ShoeStore from './ShoeStore';

function App() {
  return (
    <div className="App">
      <ShoeStore />
    </div>
  );
}

export default App;
